import { saveAs } from 'file-saver-es';
import { Component, OnInit } from "@angular/core";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import * as moment from "moment";
import { all } from "underscore";
import { ArAging } from "../../../model/ar-aging";
import { BudgetServiceService } from "../../../services/budget-service.service";
import { CreateloadService } from "../../../services/createload.service";
import { CustomersService } from "../../../services/customers.service";
import { ReportService } from "../../../services/report.service";

@Component({
  selector: "app-aragingmanagementreport",
  templateUrl: "./aragingmanagementreport.component.html",
  styleUrls: ["./aragingmanagementreport.component.scss"],
  providers: [
    ReportService,
    BudgetServiceService,
    CreateloadService,
    CustomersService,
  ],
})
export class AragingmanagementreportComponent implements OnInit {
  arAgings: ArAging[] = [];
  arAgingsConstant: ArAging[] = [];
  arAging = {
    asOfDate: "",
    customer: "",
    load: "",
  };
  // auto complete section start
  customers: any[] = [];
  customersConstant: any[] = [];
  customerNameIdMap = {};

  loads: any[] = [];
  loadsConstant: any[] = [];
  loadNameIdMap = {};
  readonly allowedPageSizes = [5, 10, 'all'];
  //auto complete section end
  constructor(
    public _reportArAgingService: ReportService,
    private arAgingService: BudgetServiceService,
    private customersService: CustomersService,
    private loadservice: CreateloadService
  ) {}

  ngOnInit() {
    this._reportArAgingService.getArAgingData().subscribe((data) => {
      this.arAgings = data.result;
      this.arAgingsConstant = data.result;
      console.log("araging ", data.result);
    });
    this.getAllBudget();
    this.getCustomers();
    this.getAllLoads();
  }

  // get data section start
  getCustomers() {
    this.customersService.getCustomersData().subscribe((data) => {
      this.customers = data.result;
      this.customersConstant = data.result;
      data.result.forEach((customer) => {
        this.customerNameIdMap[customer._id] = customer.name;
      });
    });
  }

  getAllLoads() {
    this.loadservice.getLoadData().subscribe((data) => {
      this.loads = data.result;
      this.loadsConstant = data.result;
      data.result.forEach((load) => {
        this.loadNameIdMap[load._id] = load.loadNumber;
      });
    });
  }

  //get data section end
  // searchable dropdowm section start

  onCustomerChange(value: string) {
    if (value != "" && value != undefined) {
      const filterValue = value.replace(/[\W_]/g, "").toLowerCase();
      this.customers = this.customersConstant.filter((option) =>
        option.name.replace(/[\W_]/g, "").toLowerCase().includes(filterValue)
      );
    } else {
      this.arAging.customer = "";
      this.customers = this.customersConstant;
      this.arAgings = this.arAgingsConstant;
    }
  }
  customerSelect(customerId) {
    this.arAging.customer = customerId;
  }

  onLoadChange(value: string) {
    if (value != "" && value != undefined) {
      const filterValue = value.replace(/[\W_]/g, "").toLowerCase();
      this.loads = this.loadsConstant.filter(
        (option) => option.loadNumber.toString().replace(/[\W_]/g, "").toLowerCase().includes(filterValue)
      );
    } else {
      this.arAging.load = "";
      this.loads = this.loadsConstant;
      this.arAgings = this.arAgingsConstant;
    }
  }
  loadSelect(loadId) {
    this.arAging.load = loadId;
  }

  // searchable dropdowm section end

  // submit form
  onArAgingFilter() {
    console.log(this.arAging);
    this.arAgings = this.arAgingsConstant;
    for (const [key, value] of Object.entries(this.arAging)) {
      if (value && key == "customer") {
        this.arAgings = this.arAgings.filter((option) => {
          if (option.customerId == value) {
            return option;
          }
        });
      } else if (value && key == "load") {
        this.arAgings = this.arAgings.filter((option) => {
          let allLoadIds = option.loadId.split(",");
          var flag = false;
          allLoadIds.forEach((data) => {
            if (data.trim() == value) {
              flag = true;
            }
          });
          if (flag) {
            return option;
          }
        });
      } else if (key == "asOfDate" && value) {
        const currentMonth = moment().format("YYYY-MM-DD");
        this.arAgings = this.arAgings.filter((option) => {
          let allDueDates = option.dueDate.split(",");
          var flag = false;
          allDueDates.forEach((data) => {
            if (moment(data.trim()) <= moment(value)) {
              flag = true;
            }
          });
          if (flag) {
            return option;
          }
        });
      }
    }
  }
  onFilterReset() {
    this.arAging = {
      asOfDate: "",
      customer: "",
      load: "",
    };
    this.customers = this.customersConstant;
    this.loads = this.loadsConstant;
    this.arAgings = this.arAgingsConstant;
  }
  // submit form

  //backend api call
  getAllBudget() {
    this.arAgingService.getAllBudget().subscribe((data) => {
      data.result.forEach((data) => {
        data["pricePerMile"] = data.sales / data.miles;
      });
      this.arAgings = data.result;
      this.arAgingsConstant = data.result;
    });
  }
  onExporting(e) {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet("AR Aging Report");
    var date = new Date();
    var yyyy = date.getFullYear().toString();
    var mm = (date.getMonth() + 1).toString();
    var dd = date.getDate().toString();
    const hh = date.getHours().toString();
    const min = date.getMinutes().toString();
    const sec = date.getSeconds().toString();
    const dateFormat =
      yyyy +
      "-" +
      (mm[1] ? mm : "0" + mm[0]) +
      "-" +
      (dd[1] ? dd : "0" + dd[0]) +
      " " +
      hh +
      "_" +
      min +
      "_" +
      sec;

    exportDataGrid({
      component: e.component,
      worksheet,
      autoFilterEnabled: true,
    }).then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(
          new Blob([buffer], { type: "application/octet-stream" }),
          `ARAgingReport- ${dateFormat}.xlsx`
        );
      });
    });
    e.cancel = true;
  }
  customizeAmount(data){
    return Number(Number(data.value).toFixed(2))?.toLocaleString()
  }
}
